import { makeActionCreator } from '../../../../utilities'
import { EmployerConstants } from './employer.constants'

export const setIndustry = makeActionCreator(EmployerConstants.SET_INDUSTRY, 'industry')
export const setOccupation = makeActionCreator(EmployerConstants.SET_OCUPATION, 'occupation')
export const setPrimaryBusiness = makeActionCreator(EmployerConstants.SET_PRIMARY_BUSINESS, 'primaryBusiness')
export const setAddress1 = makeActionCreator(EmployerConstants.SET_ADDRESS1, 'address1')
export const setAddress2 = makeActionCreator(EmployerConstants.SET_ADDRESS2, 'address2')
export const setCity = makeActionCreator(EmployerConstants.SET_CITY, 'city')
export const setState = makeActionCreator(EmployerConstants.SET_STATE, 'state')
export const setZipCode = makeActionCreator(EmployerConstants.SET_ZIPCODE, 'zipCode')
export const setCounty = makeActionCreator(EmployerConstants.SET_COUNTY, 'county')
export const setCountry = makeActionCreator(EmployerConstants.SET_COUNTRY, 'country')
export const setPhoneNumber = makeActionCreator(EmployerConstants.SET_PHONENUMBER, 'phoneNumber')
export const setPhoneType = makeActionCreator(EmployerConstants.SET_PHONETYPE, 'phoneType')
export const setEmployer = makeActionCreator(EmployerConstants.SET_EMPLOYER, 'employer')
export const resetEmployerState = makeActionCreator(EmployerConstants.RESET_EMPLOYER_STATE)
export const getEmployerCountyOptions = makeActionCreator(EmployerConstants.GET_EMPLOYER_COUNTY_OPTIONS)
